export function playHistorySuctionAnimation({ sourceEl, targetEl, label = 'Audio' } = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (!sourceEl || !targetEl) return;

  const sourceRect = sourceEl.getBoundingClientRect();
  const targetRect = targetEl.getBoundingClientRect();

  if (!sourceRect || !targetRect) return;

  const startX = sourceRect.left + sourceRect.width / 2;
  const startY = sourceRect.top + Math.min(sourceRect.height * 0.35, 48);
  const endX = targetRect.left + targetRect.width / 2;
  const endY = targetRect.top + targetRect.height / 2;

  const chip = document.createElement('div');
  chip.setAttribute('aria-hidden', 'true');
  chip.style.position = 'fixed';
  chip.style.left = `${startX}px`;
  chip.style.top = `${startY}px`;
  chip.style.transform = 'translate(-50%, -50%) scale(1)';
  chip.style.padding = '7px 10px';
  chip.style.borderRadius = '999px';
  chip.style.background = 'rgba(31, 41, 55, 0.95)';
  chip.style.border = '1px solid rgba(255,255,255,0.28)';
  chip.style.color = '#f8fafc';
  chip.style.fontSize = '12px';
  chip.style.fontWeight = '700';
  chip.style.display = 'flex';
  chip.style.alignItems = 'center';
  chip.style.gap = '6px';
  chip.style.boxShadow = '0 6px 16px rgba(0,0,0,0.35)';
  chip.style.pointerEvents = 'none';
  chip.style.zIndex = '13000';
  chip.style.backdropFilter = 'blur(2px)';
  chip.innerHTML = `<span style="font-size:12px;line-height:1">🔊</span><span>${String(label || 'Audio')}</span>`;

  document.body.appendChild(chip);

  const travel = chip.animate(
    [
      {
        left: `${startX}px`,
        top: `${startY}px`,
        transform: 'translate(-50%, -50%) scale(1)',
        opacity: 0.95,
        filter: 'blur(0px)',
      },
      {
        left: `${startX + (endX - startX) * 0.35}px`,
        top: `${startY + (endY - startY) * 0.15}px`,
        transform: 'translate(-50%, -50%) scale(0.94)',
        opacity: 0.98,
        filter: 'blur(0px)',
      },
      {
        left: `${endX}px`,
        top: `${endY}px`,
        transform: 'translate(-50%, -50%) scale(0.2)',
        opacity: 0,
        filter: 'blur(1.6px)',
      },
    ],
    {
      duration: 880,
      easing: 'cubic-bezier(0.2, 0.85, 0.2, 1)',
      fill: 'forwards',
    }
  );

  targetEl.animate(
    [
      { transform: 'scale(1)', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' },
      { transform: 'scale(1.15)', boxShadow: '0 0 0 8px rgba(37, 99, 235, 0.22), 0 2px 10px rgba(0,0,0,0.35)' },
      { transform: 'scale(1)', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' },
    ],
    {
      duration: 480,
      delay: 430,
      easing: 'ease-out',
    }
  );

  const cleanup = () => {
    if (chip.parentNode) {
      chip.parentNode.removeChild(chip);
    }
  };

  travel.onfinish = cleanup;
  travel.oncancel = cleanup;
}
